(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-picker')) {
    customElements.define(
      'bundle-picker',
      class BundlePicker extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', () => this.sync());
          requestAnimationFrame(() => this.sync());
        }

        sync() {
          const checked = this.querySelector('input[type="radio"]:checked');
          if (!checked) return;
          const scope = this.closest('.shopify-section') || document;
          const quantityInput = scope.querySelector('input[name="quantity"]');
          if (!quantityInput) return;
          quantityInput.value = checked.value;
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
